import React from 'react';
import { Link } from 'react-router-dom';
import SiteFooter from '../components/SiteFooter';
import InfrastructureBackground from '../components/experience/InfrastructureBackground';
import { ArrowRight, XCircle } from 'lucide-react';

const PilotCheckoutCancel = () => (
  <div className="landing-page">
    <InfrastructureBackground />
    <section className="section-padding" style={{ minHeight: '80vh' }}>
      <div className="max-w-[720px] mx-auto px-6 text-center">
        <span className="eyebrow"><span className="dot" />PILOT CHECKOUT</span>
        <h1 className="section-title mt-6">Checkout <em>Cancelled.</em></h1>
        <div className="mt-8 flex justify-center">
          <XCircle className="w-12 h-12 text-white/50" />
        </div>
        <p className="section-kicker mt-6 mx-auto">
          No charge was made. If you have questions about the 14-Day HVAC Pilot or want a
          different start time, reply to your consultation thread or reach us directly.
        </p>
        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <a href="mailto:yovel@yovaiagency.com" className="btn-primary" data-testid="pilot-cancel-email">
            Email The Team <ArrowRight className="w-4 h-4" />
          </a>
          <Link to="/" className="btn-secondary" data-testid="pilot-cancel-home">
            Back To YOVAI <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
    <SiteFooter />
  </div>
);

export default PilotCheckoutCancel;
